import Vue from "vue";
import { handleErrors } from "../modules/DisplayMessagesModule";
import { SnackBarModule } from "../modules/SnackBarModule";

const VUE_APP_RASTRO_API = process.env.VUE_APP_RASTRO_API;

export const BaseService = {
  async fetchResponseFromAPIGet(endpoint) {
    try {

      const response = await fetch(`${VUE_APP_RASTRO_API}/v1/${endpoint}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${Vue.prototype.$keycloak.token}`,
        },
      });

      const responseJson = await response.json();

      if (!response.ok) {

        const errorMessage = responseJson.message || "Erro desconhecido";

        await handleErrors(responseJson);

        return { error: true, message: errorMessage };
      }

      return { error: false, data: responseJson.data, message: "" };

    } catch (error) {
      console.error("Erro ao fazer a requisição:", error);
      throw error;
    }
  },

  async fetchResponseFromAPIPost(endpoint, postData, ignoreMessages = false) {
    let headers = {
      Accept: "application/json",
      Authorization: `Bearer ${Vue.prototype.$keycloak.token}`,
    };

    if (!(postData instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    try {
      const response = await fetch(`${VUE_APP_RASTRO_API}/v1/${endpoint}`, {
        method: "POST",
        headers,
        body: postData,
      });

      const responseJson = await response.json();

      if (!response.ok) {

        const errorMessage = responseJson.message || "Erro desconhecido";

        await handleErrors(responseJson);

        return { error: true, message: errorMessage };
      }

      if (!ignoreMessages && responseJson.message) {
        if (responseJson.warn) {
          SnackBarModule(responseJson.message, "warning");
        } else {
          SnackBarModule(responseJson.message, "success");
        }
      }

      return { error: false, data: responseJson.data, message: "" };

    } catch (error) {
      console.error("Erro ao fazer a requisição:", error);
      throw error;
    }
  },

  async fetchResponseFromAPIPut(endpoint, postData) {
    const data = {
      message: "",
      error: false,
    };
    let headers = {
      Accept: "application/json",
      Authorization: `Bearer ${Vue.prototype.$keycloak.token}`,
    };

    if (!(postData instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    try {
      let response;
      await fetch(`${VUE_APP_RASTRO_API}/v1/${endpoint}`, {
        method: "PUT",
        headers,
        body: postData,
      }).then((result) => {
        response = result;
        if (!response.ok) {
          throw response.json();
        }

        data.message = response.json();
      });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }

    return data;
  },

  async fetchResponseFromAPIDelete(endpoint) {
    const data = {
      message: "",
      error: false,
    };

    try {
      let response;
      await fetch(`${VUE_APP_RASTRO_API}/v1/${endpoint}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${Vue.prototype.$keycloak.token}`,
        },
      }).then((result) => {
        response = result;
        if (!response.ok) {
          throw response.json();
        }

        data.message = response.json();
      });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }

    return data;
  },

  async downloadItemPost(endpoint, postData) {
    const data = {
      message: "",
      error: false,
      file: null,
    };

    let headers = {
      Accept: "application/json",
      Authorization: `Bearer ${Vue.prototype.$keycloak.token}`,
    };

    if (!(postData instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    try {
      await fetch(`${VUE_APP_RASTRO_API}/v1/${endpoint}`, {
        method: "POST",
        headers,
        body: postData,
      })
        .then(res => {
          if (!res.ok) {
            throw res.json();

          }
          return res.blob();
        })
        .then(blob => {
          var file = window.URL.createObjectURL(blob);
          window.open(file, '_blank');

        });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }
    return data;
  },

};